export default __webpack_public_path__ + "static/media/9.4edb435e.jpg";